import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  get(endpoint: string) {
    return this.http.get(`${api.baseUrl + endpoint}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
      },
    });
  }

  put(endpoint: string, dataArray: any) {
    return this.http.put(`${api.baseUrl + endpoint}`, dataArray, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
      },
    });
  }

  post(endpoint: string, dataArray: any) {
    return this.http.post(`${api.baseUrl + endpoint}`, dataArray, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
      },
    });
  }

  update(endpoint: string, dataArray: any) {
    return this.http.patch(`${api.baseUrl + endpoint}`, dataArray, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
      },
    });
  }

  delete(endpoint: string) {
    return this.http.delete(`${api.baseUrl + endpoint}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
      },
    });
  }
}
